'use strict';

/**
 * Lazily creates a Zustand store and pins it on globalThis so separate webpack
 * entries (product.js, react_islands, etc.) share one instance per slice key.
 *
 * @template State
 * @param {string} globalKey
 * @param {() => State} createState
 * @returns {import('zustand/vanilla').StoreApi<State>}
 */
function getOrCreateGlobalStore(globalKey, createState) {
	const existingStore = globalThis?.[globalKey];
	if (existingStore) {
		return existingStore;
	}

	const { createStore } = require('zustand/vanilla');
	const store = createStore(createState);

	if (globalThis) {
		globalThis[globalKey] = store;
	}

	return store;
}

module.exports = {
	getOrCreateGlobalStore,
};
